import React from "react";
import "./about.css";

function About(props) {
  return (
    <div className="containers">
      <div className="home_page my-2">
        <h3>
          Home <i class="bi bi-chevron-right"></i>{" "}
        </h3>
        <p>About</p>
      </div>
      <div className="about_main mb-4 py-5">
        <div className="row">
          <div className="col-md-6">
            <div className="about_left">
              <h1 className="fs-4">Sayt haqida</h1>
              <p>
                Tahlil24.uz internet nashri o‘z oldiga qo‘ygan maqsadlarini
                bayon qilinadi. Imkoni bo‘lsa, statistik ma’lumotlarni (mijozga
                nega aynan ushbu nashrda reklama berishi kerakligini yetkazish
                uchun) keltirish kerak.
              </p>
            </div>
          </div>
          <div className="col-md-6">
          <div className="about_right">
          <h1 className="fs-4">Tahlil24.uz sayti materiallaridan foydalanish shartlari</h1>
          <p>
            Sayt materiallaridan to‘liq yoki qisman foydalanilganda veb-sayt
            manzili ko‘rsatilishi shart.
          </p>
          <p>
            Rasmiy xabarlarda va bloglarda ketgan ma’lumot - maqolalarga
            mualliflar va blogerlarning o‘zlari mas’uldirlar.
          </p>
        </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
